import { TemplatePage } from './types';

const listiclesPage: TemplatePage = {
  header: {
    color: '#FDD1E0',
    icon: 'images/video-templates/listicle.jpg',
    title: 'Listicle Video Templates',
    title_meta: '50+ Customizable and Free Listicle Video Templates',
    description_meta:
      'Breathe new life into your list-based content with Wave.video’s collection of 50+ editable listicle video ' +
      'templates.',
    description:
      'Breathe new life into your list-based content with the collection of editable listicle video templates. ' +
      'Delight your audience with easily digestible videos that are both engaging and informative.'
  },
  footer: {
    category: 'Listicle',
    description:
      'With extensive collection of listicle video templates, you can easily create engaging videos ' +
      'for your social media, blog, website, or email newsletter in a matter of minutes. All the templates are ' +
      'free and easy to customize to suit your brand and industry.'
  },
  content: [
    {
      type: 'templates',
      title: 'Listicle Videos',
      search: { category: '/Use Cases/Listicles' }
    },
    {
      type: 'stocks',
      title: 'listicles',
      search: { category: 'listicles' }
    },
    { type: 'calendar' }
  ]
};

export default listiclesPage;
